var ReactInputsValidation = require('./lib/components/index.js');

exports.Textbox = ReactInputsValidation.Textbox;
exports.Textarea = ReactInputsValidation.Textarea;
exports.Radiobox = ReactInputsValidation.Radiobox;
exports.Checkbox = ReactInputsValidation.Checkbox;
exports.Select = ReactInputsValidation.Select;